import { render, staticRenderFns } from "./CompatibleWatchesCollections.vue?vue&type=template&id=01556203&scoped=true&"
import script from "./CompatibleWatchesCollections.vue?vue&type=script&lang=js&"
export * from "./CompatibleWatchesCollections.vue?vue&type=script&lang=js&"
import style0 from "./CompatibleWatchesCollections.vue?vue&type=style&index=0&id=01556203&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01556203",
  null
  
)

export default component.exports